import "./style.css";

export default function TypingIndicator({ typingUsers, conversation, currentUser }) {
  const currentUserId = String(currentUser?.id || currentUser?._id || "");
  const typingUsersList = Object.entries(typingUsers || {})
    .filter(([userId, isTyping]) => isTyping && String(userId) !== currentUserId)
    .map(([userId]) => {
      const user = conversation?.participants?.find(
        (p) => String(p._id || p.id) === String(userId)
      );
      return user?.first_name || "User";
    })
    .filter(Boolean);

  if (typingUsersList.length === 0) {
    return null;
  }

  const getTypingText = () => {
    if (typingUsersList.length === 1) {
      return `${typingUsersList[0]} is typing…`;
    }
    if (typingUsersList.length === 2) {
      return `${typingUsersList[0]} and ${typingUsersList[1]} are typing…`;
    }
    return `${typingUsersList.length} people are typing…`;
  };

  return (
    <div className="typing_indicator" role="status" aria-live="polite">
      <span className="typing_text">{getTypingText()}</span>
      <div className="typing_dots" aria-hidden="true">
        <div className="typing_dot"></div>
        <div className="typing_dot"></div>
        <div className="typing_dot"></div>
      </div>
    </div>
  );
} 